import React, { PureComponent } from 'react'
import { string, any, func } from 'prop-types'
import Slider from 'react-slick'
import { translate } from 'react-i18next'
import { LinkButton } from 'components'

import items from './Items'
import './Carousel.css'

@translate()
export class Carousel extends PureComponent {
    static propTypes = {
        children: any,
        className: string,
        style: string,
        onSkip: func.isRequired,
        onFinish: func.isRequired
    }

    state = {
        current: 0
    }

    componentWillMount() {
        this.settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false
        }
    }

    onNext = () => {
        const { current } = this.state

        if (current === 2) {
            this.props.onFinish()
        }

        this.slider.slickNext()
        this.setState({ current: current + 1 })
    }

    render() {
        const { className, t, onSkip } = this.props

        return (
            <div className={['Carousel', className]}>
                <Slider
                    {...this.settings}
                    ref={el => {
                        this.slider = el
                    }}
                >
                    {React.Children.map(items, child => React.cloneElement(child, { key: child }))}
                </Slider>
                <div className="Carousel-links">
                    <LinkButton uppercase onClick={onSkip}>
                        {t('onboarding.carousel.skip')}
                    </LinkButton>
                    <LinkButton uppercase onClick={this.onNext}>
                        {t('onboarding.carousel.next')}
                    </LinkButton>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/components/Carousel/Carousel.js